export interface IApplicationState {
    isShowRetrigger: boolean;
    retriggerCount: any;
}

const initialState: IApplicationState = {
    isShowRetrigger: false,
    retriggerCount: -1,
};

export enum actionTypes {
    SHOW_FG_RETRIGGER = '@@retrigger/SHOW_FG_RETRIGGER',
    SET_RETRIGGER_COUNT = '@@retrigger/SET_RETRIGGER_COUNT',
    RESET_RETRIGGER = '@@retrigger/RESET_RETRIGGER',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { retriggerCount } = action;
    switch (action.type) {
        case actionTypes.SHOW_FG_RETRIGGER:
            return {
                ...state, isShowRetrigger: true
            };
        case actionTypes.SET_RETRIGGER_COUNT:
            return {
                ...state, retriggerCount: retriggerCount
            };
            case actionTypes.RESET_RETRIGGER:

                return {
                    ...state,
                    isShowRetrigger: false,
                    retriggerCount: -1,
                }
        default:
            return state;
    }
}

export const actions = {
    showFeatureRetrigger: (): any => ({ type: actionTypes.SHOW_FG_RETRIGGER }),
    resetFeatureRetrigger: (): any => ({ type: actionTypes.RESET_RETRIGGER }),
    setRetriggerCount: (retriggerCount: any): any => ({ type: actionTypes.SET_RETRIGGER_COUNT, retriggerCount }),
};
